import { FunctionComponent, useState } from "react";
import ErrorPage from "rivals/components/pages/error/ErrorPage";
import CopyToClipboardButton from "rivals/components/shared/CopyToClipboardButton";
import TextAreaInput from "rivals/components/shared/Form/TextAreaInput";
import Spinner from "rivals/components/shared/Spinner";
import { BASE_APP_HOST_URL } from "rivals/services/base";
import { PATHS } from "rivals/shared/constants";
import { AthleteViews } from "rivals/shared/interfaces/Athlete";
import { Prospect } from "rivals/shared/interfaces/Prospect";
import { setData } from "rivals/shared/utils/qa";
import ProspectCardIFrame from "./ProspectCardIFrame";
import styles from "./ProspectEmbed.module.scss";
import strings from "./strings";
import type { OwnProps } from "./types";

const { ATHLETE_CARD } = PATHS;
const buttonChangeTime = 1.5;
const { copied, copyText, iframeText, philter } = strings;

const getAthleteCardUrl = (
  activeAthleteView: AthleteViews,
  prospect: Prospect
): string => {
  return `${BASE_APP_HOST_URL}${ATHLETE_CARD.replace(
    "[slug]",
    prospect.athleteSlug
  )}?view=${activeAthleteView}&version=${1}`;
};

const ProspectEmbed: FunctionComponent<OwnProps> = ({
  activeAthleteView,
  prospect
}) => {
  let prospectEmbedPage;
  const [loadingIframe, setIframeLoading] = useState<boolean>(true);

  if (prospect) {
    const athleteCardUrl = getAthleteCardUrl(activeAthleteView, prospect);
    const textToCopy = iframeText.replace("[athleteUrl]", athleteCardUrl);

    prospectEmbedPage = (
      <div>
        <div
          className={styles.iframeContainer}
          {...setData(philter, "iframe-container")}
        >
          {loadingIframe && (
            <div
              className={styles.spinnerWrapper}
              {...setData(philter, "spinner-container")}
            >
              <Spinner />
            </div>
          )}
          <ProspectCardIFrame
            setIframeLoading={setIframeLoading}
            src={athleteCardUrl}
          />
        </div>
        <TextAreaInput
          className={styles.textBox}
          data={`${philter}-code-textbox`}
          readOnly={true}
          value={textToCopy}
        />
        <CopyToClipboardButton
          buttonClassName={styles.copyToClipboardButton}
          copiedButtonText={copied}
          copyButtonText={copyText}
          data={`${philter}-code`}
          inverted={false}
          restoreWaitTime={buttonChangeTime}
          size="small"
          textToCopy={textToCopy}
        />
      </div>
    );
  } else {
    prospectEmbedPage = <ErrorPage userError />;
  }

  return (
    <div {...setData(philter, "wrapper")} className={styles.prospectEmbed}>
      {prospectEmbedPage}
    </div>
  );
};

export default ProspectEmbed;
